import { CustomInput } from "../../kits/Inputs/Inputs";
export default function EntranceType({ changeAttributeData, data }) {
  return (
    <div className="d-flex">
      <div className="col-6 px-1">
        <CustomInput
          label="حداقل ورودی"
          inputSize="lg"
          type="text"
          inputType="input"
          inputContainer=""
          inputClassName=""
          inputValue={data.minValue}
          onChangeFunc={(e) => {
            if (!isNaN(e.target.value))
              changeAttributeData(e.target.value, "minValue");
          }}
          // textErr={validationTxt.answers}
        />
      </div>
      <div className="col-6 px-1">
        <CustomInput
          label="حداکثر ورودی"
          inputSize="lg"
          type="text"
          inputType="input"
          inputContainer=""
          inputClassName=""
          inputValue={data.maxValue}
          onChangeFunc={(e) => {
            if (!isNaN(e.target.value))
              changeAttributeData(e.target.value, "maxValue");
          }}
          // textErr={validationTxt.answers}
        />
      </div>
    </div>
  );
}
